// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import axios from "axios";
import { setSession } from "../utils/sessionstore";
import { encryptHeader } from "../utils/encryptHeader";
const API_ENDPOINT = require("../config/server");
const { getSession } = require("../utils/sessionstore");


export async function getFavouriteDashboard(token, clientid) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "GET_FAVOURITES",
      Method: "GET",
    },

    Parameters: {
      clientid: clientid,
    },
  };

  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV":iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
  };

  const response = await axios(axiosoptions);

  return response.data;
}

export async function getAvailableDashboardFor(token, clientid) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "GET_AVAILABLE_FOR_FAVOURITE",
      Method: "GET",
    },

    Parameters: {
      clientId: clientid,
    },
  };

  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV": iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
  };

  const response = await axios(axiosoptions);

  return response.data;
}

export async function addFavouriteDashboard(token, payload) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "CREATE_FAVOURITE",
      Method: "POST",
    },

    Parameters: {
      data: { favourite: payload },
    },
  };

  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV": iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
  };

  const response = await axios(axiosoptions);
  // console.log(response, "from add fav");

  return response.data;
}

export async function removeFavouriteDashboard(token, dashboardId, clientId) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "DELETE_FAVOURITE",
      Method: "DELETE",
    },

    Parameters: {
      data: { id: dashboardId,
        client_id:clientId,
      userId:token }
       },
    }

    const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV": iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
  };

  const response = await axios(axiosoptions);

  return response.data;
}
